import Vue from 'vue';
export default {
    install(){
        Vue.prototype.$client = new Vue({
            data: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight,
                isMobile: document.documentElement.clientWidth < 769
            }
        })
        window.addEventListener('resize', () => {
            Vue.prototype.$client.width = document.documentElement.clientWidth
            Vue.prototype.$client.height = document.documentElement.clientHeight
        })
    }
}
